import BoardContainer from "../board/BoardContainer";

const categories = [
  { postType: 'PT06', title: '공지', sectionTitle: '공지' },
  { postType: 'PT060', title: '광장 공지', sectionTitle: '광장 공지' },
  { postType: 'PT061', title: 'N블로그 공지', sectionTitle: 'N블로그 공지' },
  { postType: 'PT062', title: 'N플레이스 공지', sectionTitle: 'N플레이스 공지' },
  { postType: 'PT063', title: 'N통합검색 공지', sectionTitle: 'N통합검색 공지' },
];


const NoticeBoard = () => {
    return (
        <BoardContainer categories={categories} postType="PT060" />
    )
}

export default NoticeBoard;